var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlvotechManufacturinCenters(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#222222;}\n\t.st1{fill:#F69D25;}\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#F69D25;}\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#222222;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pipline"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "biosimilar"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "employees"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "network"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "generic-projects"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "manufacturing-centers"
  }, /*#__PURE__*/React.createElement("g", {
    id: "color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.4,
    y: 267.3,
    className: "st2",
    width: 25.9,
    height: 43.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.2,
    y: 345.1,
    className: "st2",
    width: 25.9,
    height: 43.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 94.4,
    y: 345.1,
    className: "st2",
    width: 25.9,
    height: 43.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 345.1,
    className: "st2",
    width: 25.9,
    height: 43.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250,
    y: 267.3,
    className: "st2",
    width: 25.9,
    height: 43.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 172.2,
    y: 267.3,
    className: "st2",
    width: 25.9,
    height: 43.2
  })), /*#__PURE__*/React.createElement("path", {
    id: "neutral",
    className: "st3",
    d: "M466.1,457L441.8,57.2c-1.3-13.1-11.9-23.3-24.2-23.3h-45.8c-13.6,0-24.2,10.3-24.2,22.5 l-16.2,168.5c-1.1-0.5-2.4-0.8-3.7-0.8h-8.6v-51.9c0-3-1.5-5.7-4-7.3c-2.5-1.6-5.6-1.8-8.3-0.5l-126,58.8v-42.3 c0-3-1.6-5.9-4.2-7.4c-2.6-1.6-5.8-1.6-8.5-0.2L38.5,242.4c-2.8,1.5-4.6,4.4-4.6,7.6v207.5c0,4.8,3.9,8.6,8.6,8.6h414.9 c2.4,0,4.7-1,6.3-2.7C465.4,461.7,466.2,459.4,466.1,457z M51.2,448.9V255.2l112.4-59.9v37.5c0,4.8,3.9,8.6,8.6,8.6h8.6 c1.3,0,2.5-0.3,3.7-0.8l117.4-54.8v46.9c0,4.8,3.9,8.6,8.6,8.6h8.6v112.4c0,4.6,3.6,8.4,8.2,8.6c4.5,0.3,8.6-3.2,9-7.8L365,57.2 c0-4.2,3.5-6.1,6.9-6.1h45.8c3.3,0,6.5,3.6,6.9,7.4l23.6,390.3H51.2z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "key-growth"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "molecule"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "green"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "map"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "playground"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "microscope"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "basket"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "hand-pill"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "cosmetics"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "medical"
  })));
}

export default SvgAlvotechManufacturinCenters;